import { BehaviorSubject } from 'rxjs';

export enum STATUS {
  pending = 'pending',
  loading = 'loading',
  success = 'success',
  error = 'error',
}

export interface IHttpData<T> {
  httpData$: BehaviorSubject<T|null>;
  httpStatus$: BehaviorSubject<STATUS>;
  httpError$: BehaviorSubject<string | null>;

  fetchData(): void;
}
